<template>
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1.0" />
      <title>cabacob2b</title>
    </head>
    <body>
      <main class="form-signin" v-if="getToken === ''">
        <h1 class="mb-3 fw-normal">CABACO B2B</h1>
        <h1 class="h3 mb-3 fw-normal"></h1>

        <div class="form-floating">
          <input
            type="email"
            v-model="user"
            class="form-control"
            id="floatingInput"
            placeholder="name@example.com"
          />
          <label for="floatingInput">Email address</label>
        </div>
        <div class="form-floating">
          <input
            type="password"
            v-model="password"
            class="form-control"
            id="floatingPassword"
            placeholder="Password"
          />
          <label for="floatingPassword">Password</label>
        </div>

        <button class="w-100 btn btn-lg btn-primary" @click="handleLogin">
          Logga in
        </button>
      </main>
      <div v-else>
        {{ getUserId }} with token: {{ getToken }}
        <br />
        <button @click="handleLogout">LOGOUT</button>
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Login",
  data: () => ({
    user: "",
    password: ""
  }),
  computed: {
    ...mapGetters(["getToken", "getUserId"])
  },
  methods: {
    ...mapActions(["loginSession", "logoutSession", "getSession"]),
    handleLogin() {
      try {
        console.log("post");

        axios
          .post(
            "https://eavedev.eu.ngrok.io/api/1/login",
            {
              email: this.user,
              password: this.password
            },
            {
              headers: { "Content-Type": "multipart/form-data" }
            }
          )
          .then(response => {
            console.log(response);
            if (response.status === 201) {
              this.loginSession(response.data.data);
              console.log(response.data.data);
              window.location.href = '/';
            }
          })
          .catch(err => console.log(err));
      } catch (error) {
        console.log(error);
      }
    },
    handleLogout() {
      this.logoutSession();
    }
  },
  created() {
    this.getSession();
  }
};
</script>

<style scoped>
body {
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue